import { render, staticRenderFns } from "./RepeateLimitArea.vue?vue&type=template&id=c6a33d2a&"
import script from "./RepeateLimitArea.vue?vue&type=script&lang=ts&"
export * from "./RepeateLimitArea.vue?vue&type=script&lang=ts&"
import style0 from "./RepeateLimitArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
